module.exports = __webpack_public_path__ + "img/SG.deda0817.svg";